import { useTranslation } from 'react-i18next';
import { BV, TV, formatVP } from '../../../../../../../helpers/helperFunctions';
import { CaptionText, H3, P1 } from '../../../../../../../styles/FontStyles';
import {
  Flexed,
  SectionSeparator
} from '../../../../../../../styles/GlobalComponents';
import { color } from '../../../../../../../styles/GlobalStyles';

export const LegInfo = ({ legName, legInfo }) => {
  const { t } = useTranslation('myTeam');
  return (
    <div>
      <P1 bold color={color.colors.neutral900}>
        {legName}
      </P1>

      <SectionSeparator margin={'12px 0'} />

      <CaptionText color={color.colors.neutral900}>Volume Points</CaptionText>

      <H3 color={color.colors.neutral900}>
        {formatVP(legInfo?.legTotalVolume) ?? 0} {TV} <br />
      </H3>
    </div>
  );
};
